import { IF360Error } from "./F360Error";

export class DownloadError<T> extends Error {
  constructor(readonly error: Pick<IF360Error<T>, "message" | "cause">) {
    super();

    this.name = "DOWNLOAD_ERROR";
    this.message = error.message;
    this.cause = error.cause;
  }
}
